requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      btn_atc_bottom: window.xQuickView.atc_btn_bottom,
      atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,
      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: [],
      cachedfetch: [],
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      isMiniCart: false,
      buttonQuickView: "",

      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
        });
      },

      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },

      load(url, el, optionId) {
        if (this.buttonQuickView == '') {
          this.buttonQuickView = el;
        }

        let variant = document.getElementById('current-variant-' + optionId).innerText;
        let productUrl = variant ? `${url}?variant=${variant}&section_id=${this.sectionId}` : `${url}?section_id=${this.sectionId}`;
        productUrl = productUrl.replace(/\s+/g, '');

        if (this.cachedResults[productUrl]) {
          document.getElementById('quickview-product-content').innerHTML = this.cachedResults[productUrl];
          return true;
        }

        if (this.cachedfetch[productUrl]) {
          return true;
        }

        this.loading = true;
        this.cachedfetch[productUrl] = true;

        fetch(productUrl)
          .then((reponse) => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const content = parser.parseFromString(response, 'text/html').getElementById('quickview-product-content').innerHTML;
            document.getElementById('quickview-product-content').innerHTML = content;
            this.cachedResults[productUrl] = content;
          })
          .finally(() => {
            this.loading = false;
            this.cachedfetch[productUrl] = false;
          });

        return true;
      },

      getCardByOptionId(optionId) {
        const chooseOptions = document.getElementById('choose-options-' + optionId);
        if (!chooseOptions) return null;
        return chooseOptions.closest('.card-product');
      },

      getSelectedCardColor(card) {
        if (!card) return null;

        const checkedInputs = card.querySelectorAll('.options-container input:checked');
        if (!checkedInputs.length) return null;

        for (const input of checkedInputs) {
          const relatedLabel = card.querySelector(`label.color-watches[for="${input.id}"]`);
          if (relatedLabel) {
            return (input.value || relatedLabel.dataset.optionvalue || relatedLabel.dataset.name || '').trim();
          }
        }

        return null;
      },

      getSelectedCardVariant(optionId) {
        const currentVariantEl = document.getElementById('current-variant-' + optionId);
        if (!currentVariantEl) return null;
        return (currentVariantEl.innerText || '').trim();
      },

      syncChooseOptionsSwatch(card, container) {
        if (!card || !container) return false;

        const selectedColor = this.getSelectedCardColor(card);
        if (!selectedColor) return false;

        const swatchInputs = container.querySelectorAll('.options-container input[type="radio"]');
        if (!swatchInputs.length) return false;

        let targetInput = null;

        swatchInputs.forEach((input) => {
          const relatedLabel = container.querySelector(`label.color-watches[for="${input.id}"]`);
          if (!relatedLabel) return;

          const inputValue = (input.value || '').trim();
          const labelValue = (relatedLabel.dataset.optionvalue || relatedLabel.dataset.name || '').trim();

          if (inputValue === selectedColor || labelValue === selectedColor) {
            targetInput = input;
          }
        });

        if (!targetInput) return false;

        if (!targetInput.checked) {
          targetInput.checked = true;
          targetInput.dispatchEvent(new Event('input', { bubbles: true }));
          targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        return true;
      },

      syncChooseOptionsAfterRender(card, container) {
        if (!card || !container) return;

        requestAnimationFrame(() => {
          this.syncChooseOptionsSwatch(card, container);

          requestAnimationFrame(() => {
            this.syncChooseOptionsSwatch(card, container);
          });
        });
      },

      resetMobileInstantAddSelection(container) {
        if (window.innerWidth > 767) return;
        if (!container) return;

        const mobilePanel = container.closest('.choose-options-mobile') || container;
        if (!mobilePanel.classList.contains('choose-options-mobile')) return;

        const sizeFieldsets = mobilePanel.querySelectorAll('.choose-option-fieldset--non-color');
        if (!sizeFieldsets.length) return;

        requestAnimationFrame(() => {
          sizeFieldsets.forEach((fieldset) => {
            const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
            if (!checkedInput) return;

            checkedInput.checked = false;
            checkedInput.removeAttribute('checked');
          });
        });
      },

      /*
      Original function kept for reference

      async loadChooseOptions(url, el, optionId, index) {
        let getVariant = document.getElementById('current-variant-' + optionId).innerText;
        let urlProduct = getVariant?`${url}?variant=${getVariant}&section_id=choose-option&page=${index}`:`${url}?section_id=choose-option&page=${index}`;

        let destinationElm = document.getElementById('choose-options-' + optionId).querySelector('.choose-options');
        let destinationElmMobile = document.getElementById('choose-options-mobile');
        let loadingEl = document.getElementById('choose-options-' + optionId).querySelector('.icon-loading');

        if ( this.loadedChooseOptions[urlProduct]) {
          if (window.innerWidth > 767) {
            destinationElm.innerHTML = this.loadedChooseOptions[urlProduct];
            destinationElmMobile.innerHTML = '';
          } else {
            destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct];
            destinationElm.innerHTML = '';
          }
          return true;
        }

        try {
          if (loadingEl) {
            loadingEl.classList.remove('hidden');
          }
          this.loadingChooseOption = true;
          const response = await fetch(urlProduct);
          const content = await response.text();

          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(content, 'text/html').getElementById("choose-options-content").innerHTML;

          if (parsedContent) {
            if (window.innerWidth > 767) {
              destinationElmMobile.innerHTML = '';
              destinationElm.innerHTML = parsedContent;
            } else {
              destinationElmMobile.innerHTML = parsedContent;
              destinationElm.innerHTML = '';
            }
            this.loadedChooseOptions[urlProduct] = parsedContent;
          }
          if (loadingEl) {
            loadingEl.classList.add('hidden');
          }
          this.loadingChooseOption = false;
        } catch (error) {
          console.log(error);
        }  
        if(window.innerWidth > 767){
          destinationElm.querySelector('.add_to_cart_button').style.display="block";
          destinationElm.querySelector('.label-btn-quickview').style.display="none";
        }else{
          destinationElmMobile.querySelector('.add_to_cart_button').style.display="block";
          destinationElmMobile.querySelector('.label-btn-quickview').style.display="none"
        }
      },
      */

      async loadChooseOptions(url, el, optionId, index) {
        const getVariant = this.getSelectedCardVariant(optionId);
        const urlProduct = getVariant ? `${url}?variant=${getVariant}&section_id=choose-option&page=${index}` : `${url}?section_id=choose-option&page=${index}`;

        const destinationElm = document.getElementById('choose-options-' + optionId).querySelector('.choose-options');
        const destinationElmMobile = document.getElementById('choose-options-mobile');
        const loadingEl = document.getElementById('choose-options-' + optionId).querySelector('.icon-loading');
        const card = this.getCardByOptionId(optionId);

        if (this.loadedChooseOptions[urlProduct]) {
          if (window.innerWidth > 767) {
            destinationElm.innerHTML = '';
            destinationElmMobile.innerHTML = '';
            destinationElm.innerHTML = this.loadedChooseOptions[urlProduct];
            this.syncChooseOptionsAfterRender(card, destinationElm);
          } else {
            destinationElmMobile.innerHTML = '';
            destinationElm.innerHTML = '';
            destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct];
            this.syncChooseOptionsAfterRender(card, destinationElmMobile);
            this.resetMobileInstantAddSelection(destinationElmMobile);
          }
          return true;
        }

        try {
          if (loadingEl) {
            loadingEl.classList.remove('hidden');
          }

          this.loadingChooseOption = true;

          const response = await fetch(urlProduct);
          const content = await response.text();

          const parser = new DOMParser();
          const parsedRoot = parser.parseFromString(content, 'text/html').getElementById('choose-options-content');
          const parsedContent = parsedRoot ? parsedRoot.innerHTML : '';

          if (parsedContent) {
            if (window.innerWidth > 767) {
              destinationElmMobile.innerHTML = '';
              destinationElm.innerHTML = '';
              destinationElm.innerHTML = parsedContent;
              this.syncChooseOptionsAfterRender(card, destinationElm);
            } else {
              destinationElmMobile.innerHTML = '';
              destinationElm.innerHTML = '';
              destinationElmMobile.innerHTML = parsedContent;
              this.syncChooseOptionsAfterRender(card, destinationElmMobile);
              this.resetMobileInstantAddSelection(destinationElmMobile);
            }

            this.loadedChooseOptions[urlProduct] = parsedContent;
          }

          if (loadingEl) {
            loadingEl.classList.add('hidden');
          }

          this.loadingChooseOption = false;
        } catch (error) {
          console.log(error);
        }

        if (window.innerWidth > 767) {
          const addToCartButton = destinationElm.querySelector('.add_to_cart_button');
          const quickViewButton = destinationElm.querySelector('.label-btn-quickview');

          if (addToCartButton) addToCartButton.style.display = 'block';
          if (quickViewButton) quickViewButton.style.display = 'none';
        } else {
          const addToCartButtonMobile = destinationElmMobile.querySelector('.add_to_cart_button');
          const quickViewButtonMobile = destinationElmMobile.querySelector('.label-btn-quickview');

          if (addToCartButtonMobile) addToCartButtonMobile.style.display = 'block';
          if (quickViewButtonMobile) quickViewButtonMobile.style.display = 'none';
        }
      },

      open(isMiniCart = false) {
        this.show = true;
        this.isMiniCart = isMiniCart;
        Alpine.store('xPopup').open = true;
      },

      close() {
        this.show = false;
        this.buttonQuickView = '';
        if (!Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
      },

      focusQuickView(quickView, btnClose) {
        if (!this.selected) {
          Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
        }
      },

      removeFocusQuickView() {
        if (!this.selected) {
          const elementActive = document.getElementById('button_quickview');
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      },

      closePopupMobile() {
        this.openPopupMobile = false;
      },

      /*
      Original function kept for reference

      showChooseOption(id, el) {
        this.openPopupMobile = true;
        const product = el.closest(".card-product");
        const addToCartBtn = product.querySelector('.choose-options').querySelector('.add_to_cart_button');
        const iconAddToCartBtn = product.querySelector('.choose-options').querySelector('.label-btn-quickview')
        const addToCartBtnMobile = document.querySelector('.choose-options-mobile').querySelector('.add_to_cart_button');
        const iconAddToCartBtnMobile = document.querySelector('.choose-options-mobile').querySelector('.label-btn-quickview')

        if(addToCartBtn && iconAddToCartBtn && window.innerWidth > 767){
          addToCartBtn.style.display="block"
          iconAddToCartBtn.style.display="none"
        }else if(addToCartBtnMobile && iconAddToCartBtnMobile){
          addToCartBtnMobile.style.display="block"     
          iconAddToCartBtnMobile.style.display="none"
        }       
      },
      */

      showChooseOption(id, el) {
        this.openPopupMobile = true;

        const product = el.closest('.card-product');
        const chooseOptions = product ? product.querySelector('.choose-options') : null;
        const chooseOptionsMobile = document.querySelector('.choose-options-mobile');

        const addToCartBtn = chooseOptions ? chooseOptions.querySelector('.add_to_cart_button') : null;
        const iconAddToCartBtn = chooseOptions ? chooseOptions.querySelector('.label-btn-quickview') : null;

        const addToCartBtnMobile = chooseOptionsMobile ? chooseOptionsMobile.querySelector('.add_to_cart_button') : null;
        const iconAddToCartBtnMobile = chooseOptionsMobile ? chooseOptionsMobile.querySelector('.label-btn-quickview') : null;

        if (addToCartBtn && iconAddToCartBtn && window.innerWidth > 767) {
          addToCartBtn.style.display = 'block';
          iconAddToCartBtn.style.display = 'none';
          this.syncChooseOptionsAfterRender(product, chooseOptions);
        } else if (addToCartBtnMobile && iconAddToCartBtnMobile) {
          addToCartBtnMobile.style.display = 'block';
          iconAddToCartBtnMobile.style.display = 'none';
          this.syncChooseOptionsAfterRender(product, chooseOptionsMobile);
          this.resetMobileInstantAddSelection(chooseOptionsMobile);
        }
      },

      clickInsideQuickView(evt, $el) {
        if (this.isMiniCart) {
          evt.stopPropagation();
          this.show = false;
          Alpine.store('xPopup').close();
        }
      },

      clickInsideContentQuickView(evt) {
        evt.stopPropagation();
      }
    });
  });
});


/* 모바일: 사이즈 선택 시 바로 ATC */
document.addEventListener('change', (event) => {
  const input = event.target;

  if (!input.matches('.choose-options-mobile input[type="radio"]')) return;

  const container = input.closest('.choose-options-mobile');
  if (!container) return;

  const fieldset = input.closest('fieldset');
  if (!fieldset || !fieldset.classList.contains('choose-option-fieldset--non-color')) return;

  const form = container.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  const submitBtn = form.querySelector('[type="submit"]');
  if (!submitBtn) return;

  setTimeout(() => {
    submitBtn.click();
  }, 50);
});



// requestAnimationFrame(() => {
//   document.addEventListener('alpine:init', () => {
//     Alpine.store('xQuickView', {
//       sectionId: window.xQuickView.sectionId,
//       enabled: window.xQuickView.enabled,
//       buttonLabel: window.xQuickView.buttonLabel,
//       show_atc_button: window.xQuickView.show_atc_button,
//       btn_atc_bottom: window.xQuickView.atc_btn_bottom,
//       atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,
//       show: false,
//       loading: false,
//       currentVariant: '',
//       cachedResults: [],
//       cachedfetch: [],
//       loadedChooseOptions: [],
//       loadedChooseOptionsID: [],
//       selected: false,
//       loadingChooseOption: false,
//       isMiniCart: false,
//       buttonQuickView: "",
//       addListener() {
//         document.addEventListener('eurus:cart:items-changed', () => {
//           this.cachedResults = [];
//         });
//       },
//       showBtn(enable, showATCButton, textBtn) {
//         this.enabled = enable;
//         this.buttonLabel = textBtn;
//         this.show_atc_button = showATCButton;
//       },
//       load(url, el, optionId) {
//         if (this.buttonQuickView == '') {
//           this.buttonQuickView = el;
//         }
//         let variant = document.getElementById('current-variant-' + optionId).innerText;
//         let productUrl = variant?`${url}?variant=${variant}&section_id=${this.sectionId}`:`${url}?section_id=${this.sectionId}`;
//         productUrl = productUrl.replace(/\s+/g, '');
        
//         if (this.cachedResults[productUrl]) {
//           document.getElementById('quickview-product-content').innerHTML = this.cachedResults[productUrl];
//           return true;
//         }
        
//         if (this.cachedfetch[productUrl]) {
//           return true;
//         }

//         this.loading = true;
//         this.cachedfetch[productUrl] = true;
//         fetch(productUrl)
//           .then(reponse => {
//             return reponse.text();
//           })
//           .then((response) => {
//             const parser = new DOMParser();
//             const content = parser.parseFromString(response,'text/html').getElementById("quickview-product-content").innerHTML;
//             document.getElementById('quickview-product-content').innerHTML = content;
//             this.cachedResults[productUrl] = content;
//           })
//           .finally(() => {
//             this.loading = false;
//             this.cachedfetch[productUrl] = false;
//           })

//         return true;
//       },
//       async loadChooseOptions(url, el, optionId, index) {
//         let getVariant = document.getElementById('current-variant-' + optionId).innerText;
//         let urlProduct = getVariant?`${url}?variant=${getVariant}&section_id=choose-option&page=${index}`:`${url}?section_id=choose-option&page=${index}`;
//         // let urlProduct = getVariant
//         //   ? `${url}?variant=${getVariant}&section_id=choose-option&page=${index}&quickadd=1`
//         //   : `${url}?section_id=choose-option&page=${index}&quickadd=1`;
        
//         let destinationElm = document.getElementById('choose-options-' + optionId).querySelector('.choose-options');
//         let destinationElmMobile = document.getElementById('choose-options-mobile');
//         let loadingEl = document.getElementById('choose-options-' + optionId).querySelector('.icon-loading');

        
//         if ( this.loadedChooseOptions[urlProduct]) {
//           if (window.innerWidth > 767) {
//             destinationElm.innerHTML = this.loadedChooseOptions[urlProduct];
//             destinationElmMobile.innerHTML = '';
//           } else {
//             destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct];
//             destinationElm.innerHTML = '';
//           }
//           return true;
//         }
        
//         try {
//           if (loadingEl) {
//             loadingEl.classList.remove('hidden');
//           }
//           this.loadingChooseOption = true;
//           const response = await fetch(urlProduct);
//           const content = await response.text();
      
//           const parser = new DOMParser();
//           const parsedContent = parser.parseFromString(content, 'text/html').getElementById("choose-options-content").innerHTML;
          
//           if (parsedContent) {
//             if (window.innerWidth > 767) {
//               destinationElmMobile.innerHTML = '';
//               destinationElm.innerHTML = parsedContent;
//             } else {
//               destinationElmMobile.innerHTML = parsedContent;
//               destinationElm.innerHTML = '';
//             }
//             this.loadedChooseOptions[urlProduct] = parsedContent;
//           }
//           if (loadingEl) {
//             loadingEl.classList.add('hidden');
//           }
//           this.loadingChooseOption = false;
//         } catch (error) {
//           console.log(error);
//         }  
//         if(window.innerWidth > 767){
//           destinationElm.querySelector('.add_to_cart_button').style.display="block";
//           destinationElm.querySelector('.label-btn-quickview').style.display="none";
//         }else{
//           destinationElmMobile.querySelector('.add_to_cart_button').style.display="block";
//           destinationElmMobile.querySelector('.label-btn-quickview').style.display="none"
//         }
        
//       },
//       open(isMiniCart = false) {
//         this.show = true;
//         this.isMiniCart = isMiniCart;
//         Alpine.store('xPopup').open = true;
//       },
//       close() {
//         this.show = false;
//         this.buttonQuickView = '';
//         if(!Alpine.store('xMiniCart').open) {
//           Alpine.store('xPopup').close();
//         }
//       },
//       focusQuickView(quickView, btnClose) {
//         if ( !this.selected ) { 
//           Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
//         }
//       },
//       removeFocusQuickView() {
//         if ( !this.selected ) { 
//           const elementActive = document.getElementById("button_quickview");
//           Alpine.store('xFocusElement').removeTrapFocus(elementActive);
//         }
//       },
//       closePopupMobile() {
//         this.openPopupMobile = false;
//       },
//       showChooseOption(id, el) {
//         this.openPopupMobile = true;
//         const product = el.closest(".card-product");
//         const addToCartBtn = product.querySelector('.choose-options').querySelector('.add_to_cart_button');
//         const iconAddToCartBtn = product.querySelector('.choose-options').querySelector('.label-btn-quickview')
//         const addToCartBtnMobile = document.querySelector('.choose-options-mobile').querySelector('.add_to_cart_button');
//         const iconAddToCartBtnMobile = document.querySelector('.choose-options-mobile').querySelector('.label-btn-quickview')

//         if(addToCartBtn && iconAddToCartBtn && window.innerWidth > 767){
//           addToCartBtn.style.display="block"
//           iconAddToCartBtn.style.display="none"
//         }else if(addToCartBtnMobile && iconAddToCartBtnMobile){
//           addToCartBtnMobile.style.display="block"     
//           iconAddToCartBtnMobile.style.display="none"
//         }       
//       },
//       clickInsideQuickView(evt, $el) {
//         if(this.isMiniCart) {
//           evt.stopPropagation();
//           this.show = false;
//           Alpine.store('xPopup').close();
//         }
//       },
//       clickInsideContentQuickView(evt) {
//         evt.stopPropagation();
//       }
//     });
//   });
// });